import {Injectable} from '@angular/core';
import {ApiService} from "../api-service/api-service";
import {AppConfig} from "../../app/app.config";


@Injectable()
export class CartService {

  constructor(public api: ApiService) {

  }

  // 加入购物车
  addCart(accountInfo: any) {
    let seq = this.api.post('v1/cart', accountInfo).share();
    seq.subscribe((res: any) => {
      if (res.code > 0) {
        AppConfig.cartNeedFresh = true;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 获取购物车列表
  getCarts(accountInfo: any) {
    let seq = this.api.get('v1/cart', accountInfo).share();
    seq.subscribe((res: any) => {
      if (res.code > 0) {
        AppConfig.cartNeedFresh = false;
      }
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 从购物车中删除
  delCarts(accountInfo: any) {
    accountInfo.id = 'delete';
    let seq = this.api.get('v1/cart/delete', accountInfo).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


}



// WEBPACK FOOTER //
// ./src/providers/data-service/cart-service.ts